import { styled } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const StyledExpandMoreIcon = styled(ExpandMoreIcon)({});
export default StyledExpandMoreIcon;
